export const TICKET_BILLING_STATUSES = {
  PENDING: 'PENDING',
  INVOICED: 'INVOICED',
  PAID: 'PAID',
  NOT_BILLABLE: 'NOT_BILLABLE'
}

export const INVOICE_STATUSES = {
  CLOSED_IN_QBO: 'CLOSED_IN_QBO',
  OPEN: 'OPEN',
  OVERDUE: 'OVERDUE',
  PAID: 'PAID',
  VOIDED: 'VOIDED',
  OVERDUE_0_30: 'OVERDUE_0_30',
  OVERDUE_31_60: 'OVERDUE_31_60',
  OVERDUE_61_90: 'OVERDUE_61_90',
  OVERDUE_ABOVE_90: 'OVERDUE_ABOVE_90'
}

export const COLORS = {
  PRIMARY: '#33CA80',
  PRIMARY_DK: '#0A3936',
  SECONDARY: '#FFE66C',
  PRIMARY_LT: '#D7F7D8',
  ALERT: '#FF8F00',
  MEDIUM_GRAY: '#6A7789',
  WARNING: '#F93B59',
  DARK_GRAY: '#131514',
  MED_DK_GRAY: '#434A54',
  TERTIARY: '#0B51AD',
  LIGHT_GRAY: '#E7E9ED',
  MINT_GRAY: '#F4F9F6',
  SHADOW: '#DDD',
  WHITE: '#FFFFFF',
  OFF_WHITE: '#EEF0F2',
  LIGHT_BLUE_GRAY: '#E5E7EB',
  SUCCESS: '#4CAF50',
  MEDIUM_YELLOW: '#FFC107',
  MEDIUM_RED: '#F44336',
  DARK_MEDIUM_GRAY: '#333',
  MED_INDIGO: '#3F51B5',
  MED_BLUE: '#2196F3'
}

export const INVOICE_STATUS_COLORS = {
  OPEN: COLORS?.ALERT,
  OVERDUE: COLORS?.WARNING,
  PAID: COLORS?.PRIMARY,
  VOIDED: COLORS?.MEDIUM_GRAY,
  CLOSED_IN_QBO: COLORS?.DARK_GRAY
}

export const INVOICE_DATE_RANGES = {
  TODAY: 'TODAY',
  YESTERDAY: 'YESTERDAY',
  THIS_WEEK: 'THIS_WEEK',
  LAST_WEEK: 'LAST_WEEK',
  THIS_MONTH: 'THIS_MONTH',
  LAST_MONTH: 'LAST_MONTH',
  LAST_3_MONTHS: 'LAST_3_MONTHS',
  LAST_6_MONTHS: 'LAST_6_MONTHS',
  THIS_YEAR: 'THIS_YEAR',
  LAST_YEAR: 'LAST_YEAR'
}

export const US_STATES_ABBR = [
  'AL',
  'AK',
  'AS',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'DC',
  'FM',
  'FL',
  'GA',
  'GU',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MH',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'MP',
  'OH',
  'OK',
  'OR',
  'PW',
  'PA',
  'PR',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'VI',
  'WA',
  'WV',
  'WI',
  'WY'
]

export const CA_PROVINCE_ABBR = [
  'AB',
  'BC',
  'MB',
  'NB',
  'NL',
  'NS',
  'NT',
  'NU',
  'ON',
  'PE',
  'QC',
  'SK',
  'YT'
]

export const DELETE_TICKETS_CONFIRMATION_MESSAGE = 'Are you sure you want to proceed with this update? ' +
  'This change applies only to Open Tickets scheduled in the future. Past, Completed, or Canceled Tickets will not be updated.'

export const HAS_RECURRING_TICKET_MESSAGE = 'One or more of the selected tickets are part of a recurring service.'
